import { combineReducers } from 'redux';
import { errorsReducer as errors } from 'iqvia-shared';
import { reducer as formReducer } from 'redux-form';

import journeyBuilderConfigurationArea from './Root';
import journeyBuilderUIDataArea from '../../JourneyBuilder/SendOptimizer/reducers';
import localizationArea from '../../Shared/CustomIntlProvider/reducers';

export default combineReducers({
  form: formReducer.plugin({}),
  errors,
  journeyBuilderConfigurationArea,
  journeyBuilderUIDataArea,
  localizationArea,
});



// WEBPACK FOOTER //
// ./src/Root/reducers/index.js